<template>
  <div class="animated fadeIn">
    <Forms
      ref="frmAssunto"
      :title="'CADASTRO DE ASSUNTO'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave"
    >
      <div class="form-group row">
        <div class="col-md-12">
          <label
            ><small
              v-if="form.nome.required"
              class="text-danger"
              >*</small
            >
            Assunto:</label
          >
          <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Digite o Nome do Assunto'"
              v-model="form.nome.value"
              :size="form.nome.maxlength"
              :required="form.nome.required"
              :state="form.nome.state"
            ></b-form-input>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import 'vue-select/dist/vue-select.css'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import AssuntoModel from '@/shared/models/configurations/assuntomodel.js'
import AssuntoForms from './assunto-form.js'
import AssuntoRepository from '@/shared/http/repositories/configurations/assunto.js'
import { advancedOnException } from '@/components/tools/Utils'

export default {
  name: 'AssuntoAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: AssuntoModel,
      form: AssuntoForms
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {},
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      loading.pop()
    },
    onCreate () {
      loading.push()
      AssuntoRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch((e) => advancedOnException(e, this.$lang))
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      AssuntoRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch((e) => advancedOnException(e, this.$lang))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/ajuizamento/assunto/components/add/assuntoadd.vue